import locale6c5af57f from '../../lang/de.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"de","silentTranslationWarn":true},
  vueI18nLoader: false,
  locales: [{"code":"de","iso":"ch-DE","file":"de.json","dir":"ltr","name":"Deutsch"},{"code":"fr","iso":"ch-FR","file":"fr.json","dir":"ltr","name":"Francais"},{"code":"it","iso":"ch-IT","file":"it.json","dir":"ltr","name":"Italiano"}],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/vercel/path0/lang",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: true,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  seo: true,
  normalizedLocales: [{"code":"de","iso":"ch-DE","file":"de.json","dir":"ltr","name":"Deutsch"},{"code":"fr","iso":"ch-FR","file":"fr.json","dir":"ltr","name":"Francais"},{"code":"it","iso":"ch-IT","file":"it.json","dir":"ltr","name":"Italiano"}],
  localeCodes: ["de","fr","it"],
  additionalMessages: [],
}

export const localeMessages = {
  'de.json': () => Promise.resolve(locale6c5af57f),
  'fr.json': () => import('../../lang/fr.json' /* webpackChunkName: "lang-fr.json" */),
  'it.json': () => import('../../lang/it.json' /* webpackChunkName: "lang-it.json" */),
}
